import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPointer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 13 18"
    {...props}
  >
    <path
      fill="#787887"
      d="M11.125 9c1.281 1.219.375 3.375-1.375 3.375h-.5l.563 1.344c.218.5.218 1.031.03 1.5-.187.5-.562.875-1.062 1.094l-1.312.562a1.99 1.99 0 0 1-2.563-1.031h-.031v-.031l-.531-1.25-.75.718C2.344 16.5.25 15.625.25 13.875V2.969c0-1.75 2.156-2.625 3.344-1.375zM9.75 10.875c.438 0 .656-.5.344-.781L2.53 2.656c-.281-.281-.781-.094-.781.313v10.906c0 .406.5.656.781.344l2.313-2.25 1.406 3.25c.125.25.406.375.625.25l1.313-.531a.448.448 0 0 0 .25-.626l-1.47-3.437z"
    />
  </svg>
);
export default SvgPointer;
